import React from 'react';
import '../styles/pages/AboutUs.css';
import '../styles/GlobalSections.css';

export default function AboutUs() {
  return (
    <div className="about-us-page">
      <section className="about-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <h1 className="hero-title">About LCS</h1>
          <p className="hero-subtitle">A Leading Indian KYC verification Service Provider</p>
          <p className="hero-description">
            Enabling India's Financial Ecosystem with Trusted KYC verification and Innovative Solutions
          </p>
        </div>
      </section>

      <section className="about-content section-white">
        <div className="container">
          <div className="about-intro">
            <h2>Who We Are</h2>
            <p>
              LCS is a leading Indian company providing KYC verification services. The company operates in India's financial sector, working with banks, NBFCs, credit cooperative societies, microfinance institutions, cooperative banks, insurance companies, and other financial institutions.
            </p>
          </div>

          <div className="about-grid">
            <div className="about-card">
              <div className="card-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                To help financial institutions ensure accurate KYC verification of loan customers before disbursing loans.
              </p>
            </div>

            <div className="about-card">
              <div className="card-icon">🔬</div>
              <h3>Our Technology</h3>
              <p>
                We use modern technology, advanced data analytics, and AI-based systems to make the loan approval process faster, 
                more secure, and transparent.
              </p>
            </div>

            <div className="about-card">
              <div className="card-icon">📊</div>
              <h3>Our Services</h3>
              <p>
               LCS provides KYC verification reports, and analyzes data that benefits institutions across various sectors, enabling better financial literacy.
              </p>
            </div>

            <div className="about-card">
              <div className="card-icon">🤖</div>
              <h3>AI & Innovation</h3>
              <p>
                Leveraging Artificial Intelligence-based systems to make loan approval processes faster, more secure, 
                and helping businesses grow successfully.
              </p>
            </div>

            <div className="about-card">
              <div className="card-icon">🛡️</div>
              <h3>Trust & Security</h3>
              <p>
                Our technology helps make the lending process fully transparent, prevents fraud, and provides effective solutions 
                for secure transactions.
              </p>
            </div>

            <div className="about-card">
              <div className="card-icon">📈</div>
              <h3>Digital Excellence</h3>
              <p>
                Over the past few years, LCS has played an important role in the financial sector by delivering digital transactions 
                and fast services.
              </p>
            </div>
          </div>

        </div>
      </section>

      <section className="about-impact-section section-light-blue">
        <div className="container">
          <div className="about-impact">
            <h2>Our Impact</h2>
            <p>
              By providing KYC Verification, we help strengthen the lending business in India. Our technology enables financial institutions to make informed decisions, improves financial literacy, and helps customers receive accurate information.
            </p>
            <p>
              Loans are issued using our data, analytics, and software. LCS is a trusted company that uses advanced data, analytics, 
              and technology, enabling lenders to make more reliable credit decisions.
            </p>
          </div>
        </div>
      </section>

      <section className="about-values-section section-white">
        <div className="container">
          <div className="about-values">
            <h2>Why Choose LCS</h2>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">✓</span>
                <span>KYC Verification Operations</span>
              </div>
              <div className="value-item">
                <span className="value-icon">✓</span>
                <span>Advanced Data Analytics</span>
              </div>
              <div className="value-item">
                <span className="value-icon">✓</span>
                <span>Real-time Processing</span>
              </div>
              <div className="value-item">
                <span className="value-icon">✓</span>
                <span>Secure Infrastructure</span>
              </div>
              <div className="value-item">
                <span className="value-icon">✓</span>
                <span>24/7 Support</span>
              </div>
              <div className="value-item">
                <span className="value-icon">✓</span>
                <span>Transparent Processes</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta section-light-blue">
        <div className="container">
          <h2>Join Our Growing Network</h2>
          <p>Partner with LCS for reliable KYC Verification services</p>
          <button className="btn-primary" onClick={() => window.location.href = '/contact'}>
            Contact Us Today
          </button>
        </div>
      </section>
    </div>
  );
}
